<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-menu-button></ion-menu-button></ion-buttons>
    <ion-title>Helyettesítés bejelentése</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <!-- A funkció intézményenként kapcsolható. Kikapcsolva a szerver is elutasít,
       ezért itt sincs értelme bármit mutatni a kapcsolón kívül. -->
  <ion-card *ngIf="admin">
    <ion-card-content class="hb-kapcsolo">
      <ion-toggle [checked]="bekapcsolva" (ionChange)="kapcsoloValt($event.detail.checked)">
        Utólagos helyettesítés-bejelentés engedélyezése
      </ion-toggle>
      <div class="hb-sugo">
        Bekapcsolva a kollégák jelezni tudják, ha olyan órát tartottak meg, amire nem
        voltak előre kiírva. A bejelentés <b>nem változtatja meg az órarendet</b> – azt
        csak a jóváhagyás írja be.
      </div>
      <ion-toggle [checked]="automata" [disabled]="!bekapcsolva" (ionChange)="automataValt($event.detail.checked)">
        Automatikus jóváhagyás
      </ion-toggle>
      <div class="hb-sugo">
        Bekapcsolva a bejelentés <b>azonnal bekerül az órarendbe</b>, ha az órán nincs más helyettesítő,
        és más kolléga sem jelentette be ugyanazt (vitás esetben marad a jóváhagyásra várók között).
        A kolléga a saját bejelentését ezután is visszavonhatja, és te is bármikor visszavonhatod.
      </div>
    </ion-card-content>
  </ion-card>

  <div class="hb-ures" *ngIf="!bekapcsolva && !toltodik">
    Ez a funkció ennél az intézménynél nincs bekapcsolva.
    <span *ngIf="!admin">Ha szükség lenne rá, az intézményi adminisztrátor kapcsolhatja be.</span>
  </div>

  <ng-container *ngIf="bekapcsolva">
    <!-- ── ELMARADT ÓRÁIM ────────────────────────────────────────────────
         A másik irány: nem én tartottam meg más óráját, hanem az enyémet nem tartotta meg
         senki (táppénz, szabadság). Ezek ne számítsanak könyveletlennek. -->
    <ion-card>
      <ion-card-content class="hb-kapcsolo">
        <b>Elmaradtak az óráim</b>
        <div class="hb-sugo">Ha beteg voltál, és senki nem helyettesített, jelöld itt – így ezek az órák nem számítanak
          könyveletlennek, és ki tudod nyomtatni az elszámolásod. A már beírt és a más által helyettesített órák nem változnak.</div>
        <div style="display:flex; gap:8px; flex-wrap:wrap; align-items:center">
          <label>Mettől <input type="date" [(ngModel)]="elmaradtTol"></label>
          <label>Meddig <input type="date" [(ngModel)]="elmaradtIg"></label>
          <ion-button size="small" (click)="elmaradtJelol()" [disabled]="!elmaradtTol || elmaradtFut">Elmaradtnak jelölöm</ion-button>
        </div>
      </ion-card-content>
    </ion-card>
    <!-- ── BEJELENTÉS ─────────────────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Megtartottam egy órát, amire nem voltam kiírva</ion-card-title>
        <ion-card-subtitle>
          Válaszd ki a napot és az órát, amit megtartottál. A saját óráid nem jelennek meg
          a listában – azok nem helyettesítések. Jövőbeli órát nem lehet bejelenteni.
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div class="hb-fejlec">
          <ion-input label="Nap" label-placement="stacked" fill="outline" type="date"
                     [(ngModel)]="datum"></ion-input>
          <ion-select label="Osztály (nem kötelező)" label-placement="stacked" fill="outline"
                      interface="popover" [(ngModel)]="osztaly">
            <ion-select-option value="">mind</ion-select-option>
            <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">{{ o.osztaly }}</ion-select-option>
          </ion-select>
          <ion-input label="Hányadik óra (nem kötelező)" label-placement="stacked" fill="outline"
                     type="number" min="1" max="12" inputmode="numeric" placeholder="mind"
                     [(ngModel)]="oraSzam"></ion-input>
          <ion-button (click)="orakBetolt()" [disabled]="orakFut">
            <ion-icon slot="start" name="search-outline"></ion-icon>Órák lekérése
          </ion-button>
        </div>

        <div class="hb-fejlec" *ngIf="orak?.length">
          <ion-select label="Tanár (kinek az órája)" label-placement="stacked" fill="outline"
                      interface="popover" [(ngModel)]="tanarSzuro">
            <ion-select-option value="">mind</ion-select-option>
            <ion-select-option *ngFor="let t of tanarok" [value]="t">{{ t }}</ion-select-option>
          </ion-select>
        </div>

        <div class="hb-allapot" *ngIf="orakFut"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>

        <div class="hb-ures" *ngIf="orak && !orak.length && !orakFut">
          Ezen a napon nincs olyan óra, amit bejelenthetnél. (A saját óráid nem szerepelnek itt.)
        </div>

        <div class="hb-tabla-burok" *ngIf="orak?.length">
          <table class="hb-tabla">
            <thead><tr>
              <th></th><th>Óra</th><th>Osztály / csoport</th><th>Tantárgy</th><th>Terem</th>
              <th>Kinek az órája</th><th>Jelenlegi helyettesítő</th><th></th>
            </tr></thead>
            <tbody>
              <tr *ngFor="let o of szurtOrak" [class.valasztott]="valasztottOra?.id === o.id">
                <td><input type="radio" [checked]="valasztottOra?.id === o.id"
                           (change)="valasztottOra = o" [disabled]="!!o.bejelentes_id" /></td>
                <td>{{ o.ora }}.</td>
                <td>{{ o.csoport_nev || o.osztaly_nev }}</td>
                <td>{{ o.tantargy_nev }}</td>
                <td [class.halvany]="!o.terem">{{ o.terem || '–' }}</td>
                <td>{{ o.tanar_nev }}</td>
                <td [class.halvany]="!o.helyettesito_nev">{{ o.helyettesito_nev || '–' }}</td>
                <td>
                  <!-- Már van rá függő bejelentés: ne lehessen kétszer beküldeni. -->
                  <span class="hb-jel" *ngIf="o.bejelentes_id">
                    már bejelentve{{ o.bejelentes_bejelento === allomany ? ' (általad)' : '' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="hb-urlap" *ngIf="valasztottOra">
          <b>{{ oraCim(valasztottOra) }}</b> – eredetileg {{ valasztottOra.tanar_nev }} órája
          <div class="hb-fejlec">
            <ion-select label="Típus" label-placement="stacked" fill="outline" interface="popover"
                        [(ngModel)]="tipus">
              <ion-select-option *ngFor="let t of TIPUSOK" [value]="t.e">{{ t.n }}</ion-select-option>
            </ion-select>
            <ion-select label="Mód" label-placement="stacked" fill="outline" interface="popover"
                        [(ngModel)]="mod">
              <ion-select-option *ngFor="let m of MODOK" [value]="m.e">{{ m.n }}</ion-select-option>
            </ion-select>
            <ion-input label="Megjegyzés" label-placement="stacked" fill="outline"
                       placeholder="pl. a kolléga reggel megbetegedett" [(ngModel)]="indok"></ion-input>
            <ion-button color="success" (click)="bejelent()" [disabled]="kuldFut">
              <ion-icon slot="start" name="send-outline"></ion-icon>Bejelentem
            </ion-button>
          </div>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- ── LISTA / ELBÍRÁLÁS ──────────────────────────────────────────── -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>{{ admin ? 'Bejelentések' : 'Bejelentéseim' }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-segment class="hb-nezet" [(ngModel)]="nezet" (ionChange)="betolt()">
          <ion-segment-button value="sajat"><ion-label>Sajátjaim</ion-label></ion-segment-button>
          <ion-segment-button value="fuggo" *ngIf="admin"><ion-label>Jóváhagyásra vár</ion-label></ion-segment-button>
          <ion-segment-button value="mind" *ngIf="admin"><ion-label>Mind</ion-label></ion-segment-button>
        </ion-segment>

        <div class="hb-allapot" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
        <div class="hb-allapot hiba" *ngIf="hiba">{{ hiba }}</div>
        <div class="hb-ures" *ngIf="!toltodik && !tetelek.length && !hiba">Nincs megjeleníthető bejelentés.</div>

        <div class="hb-tabla-burok" *ngIf="tetelek.length">
          <table class="hb-tabla">
            <thead><tr>
              <th>Nap</th><th>Óra</th><th>Osztály</th><th>Tantárgy</th><th>Terem</th>
              <th>Bejelentő</th><th>Eredeti tanár</th><th>Típus / mód</th>
              <th>Állapot</th><th *ngIf="admin">Elbírálás</th>
            </tr></thead>
            <tbody>
              <tr *ngFor="let b of tetelek" [class]="'allapot-' + b.allapot">
                <td>{{ b.datum }}</td>
                <td>{{ b.oraszam }}.</td>
                <td>{{ b.csoport_nev || b.osztaly_nev }}</td>
                <td>{{ b.tantargy_nev }}</td>
                <td [class.halvany]="!b.terem">{{ b.terem || '–' }}</td>
                <td>{{ b.bejelento_nev }}</td>
                <td>{{ b.eredeti_tanar_nev }}</td>
                <td>{{ tipusNev(b.tipus) }} / {{ modNev(b.helyettesites_mod) }}</td>
                <td>
                  <span class="hb-cimke" [class]="'a-' + b.allapot">{{ ALLAPOT_NEV[b.allapot] }}</span>
                  <div class="halvany" *ngIf="b.indok">„{{ b.indok }}"</div>
                  <div class="halvany" *ngIf="b.dontes_indok">
                    {{ b.dontotte_nev }}: {{ b.dontes_indok }}
                  </div>
                  <!-- Az órán szereplő helyettesítő nem mindig a bejelentő: ha eltér,
                       azt látni kell, mielőtt bárki jóváhagy. -->
                  <div class="hb-figyelem"
                       *ngIf="b.allapot === 'fuggo' && b.ora_helyettesito && b.ora_helyettesito !== b.bejelento">
                    Az órán jelenleg {{ b.ora_helyettesito_nev }} a helyettesítő.
                  </div>
                  <ion-button size="small" fill="clear" color="medium" *ngIf="(b.allapot === 'fuggo' || b.allapot === 'jovahagyva') && sajatE(b)"
                              (click)="sajatVisszavon(b)" [disabled]="dontesFut === b.id">Visszavonom (mégse kell)</ion-button>
                </td>
                <td *ngIf="admin">
                  <ng-container *ngIf="b.allapot === 'fuggo'">
                    <input class="hb-indok" placeholder="indok (elutasításhoz kötelező)"
                           [(ngModel)]="dontesIndok[b.id]" />
                    <ion-button size="small" color="success" (click)="dontes(b, 'jovahagy')"
                                [disabled]="dontesFut === b.id">Jóváhagy</ion-button>
                    <ion-button size="small" color="danger" fill="outline" (click)="dontes(b, 'elutasit')"
                                [disabled]="dontesFut === b.id">Elutasít</ion-button>
                  </ng-container>
                  <ng-container *ngIf="b.allapot === 'jovahagyva'">
                    <input class="hb-indok" placeholder="visszavonás indoka"
                           [(ngModel)]="dontesIndok[b.id]" />
                    <ion-button size="small" color="warning" fill="outline" (click)="visszavon(b)"
                                [disabled]="dontesFut === b.id">Visszavonom</ion-button>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <small class="hb-sugo">
          A bejelentés <b>állítás</b>, a helyettesítés <b>tény</b>: az órarendbe csak a jóváhagyás
          írja be. Az elutasított bejelentés is megmarad az indokával – így utólag is látszik,
          ki mit jelentett be és ki mit döntött.
        </small>
      </ion-card-content>
    </ion-card>
  </ng-container>
</ion-content>
